$(document).ready(function () {
  const $navLinks = $('.wp-block-acf-blog-navigation__link');
  const $headings = $('.is-style-blog-heading');

  // The exact offset distance requested
  const offsetDistance = 220;

  $(window).on('scroll', function () {
    const scrollPos = $(window).scrollTop();

    $headings.each(function () {
      const $heading = $(this);
      const headingTop = $heading.offset().top;
      const id = $heading.attr('id');

      // Triggers when the screen top is 120px above the heading top
      if (scrollPos >= (headingTop - offsetDistance)) {
        $navLinks.removeClass('active');

        const $activeLink = $(`.wp-block-acf-blog-navigation__link[href="#${id}"]`);
        if ($activeLink.length) {
          $activeLink.addClass('active');
        }
      }
    });
  });
});
$('.wp-block-acf-blog-navigation__link').on('click', function (e) {
  $('.wp-block-acf-blog-navigation__link').removeClass('active');
  $(this).addClass('active')
});
